import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "contexts/AuthProvider";
import { auth } from "config/firebaseConfig";
import LoginPage from "features/auth/login-page";

const ProtectedSignIn = () => {
  const { currentUser } = useContext(AuthContext);
  return currentUser ? <Navigate to="/" /> : <LoginPage />;
};

const ProtectedRoutes = ({ children }) => {
  const { currentUser } = useContext(AuthContext);

  // 로그인은 했지만 이메일 인증이 완료되지 않은 경우
  if (currentUser && auth.currentUser && !auth.currentUser.emailVerified) {
    // verify-email 페이지로 리다이렉트 (단, 이미 verify-email 페이지에 있는 경우는 제외)
    if (window.location.pathname !== "/verify-email") {
      return <Navigate to="/verify-email" replace />;
    }
  }

  return currentUser ? children : <LoginPage />;
};

// 관리자 전용 라우트: 로그인 + 이메일 인증 + isAdmin 을 모두 만족해야 접근 가능
const AdminRoutes = ({ children }) => {
  const { currentUser, isAdmin } = useContext(AuthContext);

  // 로그인하지 않은 경우 로그인 페이지 노출
  if (!currentUser) {
    return <LoginPage />;
  }

  // 로그인은 했지만 이메일 인증이 완료되지 않은 경우
  if (auth.currentUser && !auth.currentUser.emailVerified) {
    if (window.location.pathname !== "/verify-email") {
      return <Navigate to="/verify-email" replace />;
    }
  }

  // 관리자가 아닌 경우 홈으로 리다이렉트
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export { ProtectedSignIn, ProtectedRoutes, AdminRoutes };
